<template>
  <layout page-title="Lexikon" :show-profile="true">
    <!-- Primary column -->
    <section class="min-w-0 flex-1 h-full max-w-sm mx-auto lg:order-last pt-3 px-3 pb-12 select-none">
      <img v-if="false" src="/img/participate.png" class="w-3/5 sm:w-2/5 mx-auto" />

      <img src="/img/werteraeume.png" class="w-3/5 sm:w-4/5 mx-auto my-12" />

      <h1 v-if="false" class="uppercase font-live text-[3rem] font-medium pt-4 pb-2 mx-auto text-center">
        Werteräume
      </h1>

      <!-- search field: start -->
      <div class="my-2 flex items-center gap-x-3">
        <div class="relative rounded-md shadow-sm">
          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <span class="text-gray-500 sm:text-sm"><svg xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
              </svg>
            </span>
          </div>
          <input type="text" name="search" id="search" ref="search" @click="selectAll" v-model="form.search"
            class="block w-full rounded-md border-0 py-1.5 pl-10 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-400 sm:text-sm sm:leading-6"
            placeholder="" />
          <div v-if="false" class="absolute inset-y-0 right-0 flex items-center">
            <select v-if="wordCategories.length > 0" id="category" name="category" v-model="form.category"
              class="h-full rounded-md border-0 bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-gray-400 text-sm max-w-[80px]">
              <option :value="null">Alle</option>
              <option v-for="category in wordCategories" :key="category.id" :value="category.id">
                {{ category.name }}
              </option>
            </select>
          </div>
        </div>

        <svg @click="showValueSpaceSelection = true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-500 cursor-pointer">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
      </div>
      <!-- search field: end -->

      <!-- words: start -->
      <div class="min-h-[10rem]" :class="allWords.length <= 0 ? 'border-2 border-dashed border-gray-300' : ''">
        <Splide v-if="allWords.length > 0" :options="splideOptions" ref="splider">
          <SplideSlide v-for="(paginatedWords, pageId) in allWords" :key="pageId">
            <div class="flex gap-x-5 border-y border-gray-200 py-1">
              <div class="w-full">
                <ul class="list-none divide-y" v-if="paginatedWords.length > 0">
                  <li v-for="word in paginatedWords.slice(0, 5)" :key="word.id" @click="selectWord(word)"
                    class="py-1 flex justify-between items-center text-xs" :class="word.publish_status == 'published_and_blocked'
                      ? 'cursor-default'
                      : 'cursor-pointer hover:text-gray-400'
                      ">
                    {{ word.word }}

                    <svg @click.stop="selectDefinition(word)" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      class="w-4 h-4 text-gray-400 shrink-0 cursor-pointer"
                      :class="word.definition ? 'visible' : 'invisible'">
                      <path v-if="word.publish_status == 'published_and_blocked'" stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />

                      <path v-else stroke-linecap="round" stroke-linejoin="round"
                        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                    </svg>
                  </li>
                </ul>
              </div>
            </div>
          </SplideSlide>
        </Splide>

        <div v-if="!allWords.length" class="relative block w-full rounded-lg  p-12 h-full text-center text-xs">
          <p v-if="message" v-text="message"></p>

          <p v-if="canProposeNewWord && newWordProposalSent">
            Anforderung versandt
          </p>

          <span v-if="canProposeNewWord && !newWordProposalSent"
            class="rounded-md shadow-sm inline-block text-right"><button type="button" @click="proposeNewWord"
              class="flex justify-center py-2 px-4 border border-transparent text-xs font-base rounded-md text-white bg-brandpreneurship-dark-gray focus:outline-none focus:border-black focus:shadow-outline-red active:bg-black transition duration-150 ease-in-out hover:bg-black text-right">
              Verortung anfordern
            </button></span>
        </div>
      </div>

      <!-- words: end -->

      <!-- selected words: start -->
      <div class="mt-5 mb-5 flex flex-wrap items-center gap-x-2 gap-y-2">
        <!-- <div
          v-if="!selectedWords.length"
          class=" relative block w-full  px-6 h-full text-center text-xs"
        >
          <p>Keine Worte vorhanden</p>
        </div> -->

        <div v-for="(word, idx) in selectedWords" :key="idx"
          class="inline-flex items-center justify-between gap-x-1 rounded-md border border-gray-400 px-2 py-1 text-xs">
          <span>{{ word.word }}</span>

          <zone-color-icons :colors="word.zone_colors" :mini="true"></zone-color-icons>

          <button type="button" @click="deselectWord(word)"
            class="group relative h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20">
            <svg viewBox="0 0 14 14" class="h-3.5 w-3.5 stroke-gray-700/50 group-hover:stroke-gray-700/75">
              <path d="M4 4l6 6m0-6l-6 6" />
            </svg>
            <span class="absolute -inset-1"></span>
          </button>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" @click="showValueSpaceCreation = true"
          v-if="canStoreValueSpace" class="w-5 h-5 text-gray-400 cursor-pointer hover:text-markencode-blue outline-none"
          v-tooltip.top="`Werteraum speichern`">
          <rect width="256" height="256" fill="none" />
          <path
            d="M216,91.31V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.69a8,8,0,0,1,5.65,2.34l43.32,43.32A8,8,0,0,1,216,91.31Z"
            fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
          <path d="M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64" fill="none" stroke="currentColor"
            stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
          <line x1="152" y1="72" x2="96" y2="72" fill="none" stroke="currentColor" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="16" />
        </svg>
      </div>
      <!-- selected words: end -->

      <!-- result: start -->
      <div class="mt-0 flex border-y border-gray-200 h-[3rem] py-2 items-center divide-x divide-gray-400">
        <div class="w-1/2 flex gap-x-3 items-center justify-end">
          <div>
            <spinner :busy="loading" color="#000" class="shrink-0"></spinner>

            <!-- <svg
              v-if="archetypes.length <= 0"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-7 h-7 text-markencode-yellow"
              :class="loading ? 'animate-spin' : ''"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
              />
            </svg> -->

            <svg v-if="archetypes.length > 0 && !loading && validity" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-7 text-markencode-green">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>

            <svg v-if="archetypes.length > 0 && !loading && !validity" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-7 text-markencode-red">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
          </div>
          <p class="text-sm mr-5">16</p>
        </div>
        <div class="w-1/2 flex gap-x-3 items-center">
          <p class="text-sm ml-5">40</p>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" />
          </svg>

          <p class="text-sm">in Dev.</p>
        </div>
      </div>
      <!-- result: end -->

      <!-- matrix: start -->
      <div class="mt-5">
        <div class="bg-gray-300 rounded-full mx-auto w-full relative">
          <img src="/img/markencode/markencode-doppelkreis.png" class="absolute top-0 left-0" />

          <svg-matrix :active-zones="this.selectedArchetype.activeZones" :validity="validity"
            :active-area="this.selectedArchetype.zone" :selectedWords="selectedWords" class="absolute top-0 left-0"
            style="
              width: 270px;
              height: 270px;
              margin-top: 45px;
              margin-left: 45px;
            "></svg-matrix>

          <matrix :initialZone="form.zone" :forceEnabled="true" @selected="zoneSelected" class="absolute top-0 left-0"
            style="
              width: 270px;
              height: 270px;
              margin-top: 45px;
              margin-left: 45px;
            "></matrix>
        </div>
      </div>
      <!-- matrix: end -->

      <!-- archetypes: start -->
      <div class="pt-96 sm:pt-96 pb-6 clear-both">
        <div v-if="loading" class="mt-3 w-full h-12">
          <spinner :busy="loading" color="#53C9FF"></spinner>
        </div>

        <!-- <div v-if="archetypes.length > 0 && !loading"> -->

        <Splide v-if="archetypes.length > 0 && !loading" :options="splideOptionsArchetype" ref="spliderArchetype">
          <SplideSlide v-for="(archetype, idx) in archetypes" :key="idx">
            <!-- <div class="flex items-center justify-center gap-2"> -->
            <archetype :archetype="archetype" @selected="selectArchetype(archetype)" :selected="selectedArchetype"
              class="w-10"></archetype>

            <p v-if="$page.props.auth.user.email.includes('@brandhelfer.de')" class="text-xs whitespace-nowrap"
              :class="selectedArchetype?.zone == archetype?.zone ? 'opacity-100' : 'opacity-50'">{{
                archetype.ranking ? archetype.ranking.toLocaleString('de-DE') : '0,0' }}</p>
            <!-- </div> -->
            <!-- </div> -->
          </SplideSlide>
        </Splide>

        <p class="text-xs px-2 mt-12 font-semibold"
          :class="selectedArchetype.extended_name ? 'opacity-100' : 'opacity-0'">{{
            selectedArchetype?.extended_name }}</p>
      </div>

      <!-- archetypes: end -->






      <div v-if="archetypes.length > 0 && !loading && canSeeBetaFunctionalities" class="px-2">

        <!-- options tabs: start -->
        <div class="mb-4">
          <div class="border-b border-gray-200">
            <nav aria-label="Tabs" class="-mb-px flex space-x-8">

              <a href="#" @click.prevent="activeTab = 'info'"
                class="border-b-2 px-1 py-4 text-xs font-normal whitespace-nowrap"
                :class="activeTab == 'info' ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'">Beschreibung</a>

              <a href="#" @click.prevent="activeTab = 'language'"
                class="border-b-2 px-1 py-4 text-xs font-normal whitespace-nowrap"
                :class="activeTab == 'language' ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'">Sprache</a>

              <a href="#" @click.prevent="activeTab = 'design'"
                class="border-b-2 px-1 py-4 text-xs font-normal whitespace-nowrap"
                :class="activeTab == 'design' ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'">Design</a>

              <a href="#" @click.prevent="activeTab = 'actions'"
                class="border-b-2 px-1 py-4 text-xs font-normal whitespace-nowrap"
                :class="activeTab == 'actions' ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'">Verhalten</a>

            </nav>
          </div>
        </div>
        <!-- options tabs: end -->

        <!-- actions tab: start -->
        <div v-if="activeTab == 'actions'" class="min-h-[3rem]">
          <!-- action field: start -->
          <div class="my-2 flex items-center gap-x-3">
            <div class="flex-1 relative rounded-md shadow-sm">
              <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span class="text-gray-500 sm:text-sm"><svg xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                  </svg>
                </span>
              </div>
              <input type="text" name="action" id="action" ref="action" @click="selectAllActions"
                v-model="form.actionSearch"
                class="block w-full rounded-md border-0 py-1.5 pl-10 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:text-xs focus:ring-2 focus:ring-inset focus:ring-gray-400 sm:text-sm sm:leading-6"
                :placeholder="actionPlaceholder" />
            </div>


            <svg v-if="!form.action" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-300">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

            <svg v-else @click="resetAction" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="1.5" stroke="currentColor"
              class="w-5 h-5 text-gray-500 cursor-pointer hover:text-markencode-blue">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

          </div>

          <div v-if="actionLoading || allActions.length"
            class="relative block w-full rounded-lg bg-gray-200 px-3 py-3 text-xs">
            <p v-if="actionLoading" class="animate-pulse">...</p>

            <ul>
              <li v-for="action in allActions" :key="action.id" class="py-1 hover:text-markencode-blue cursor-pointer"
                @click="selectAction(action)">
                {{ action.word }}</li>
            </ul>
          </div>
          <!-- action field: end -->


          <!-- calculated action archetypes: start -->
          <div class="min-h-96">
            <div v-if="actionCalculating" class="mt-6">
              <spinner :busy="actionCalculating" color="#000" class="shrink-0"></spinner>
            </div>

            <div v-if="!actionCalculating && displayedActionArchetypes.length" class="mt-6 space-y-2">
              <div v-for="(arch, key) in displayedActionArchetypes" :key="key" class="pb-0">

                <!-- green bar (only if barWidthPercent exists) -->
                <div v-if="arch.barWidthPercent !== undefined && arch.barWidthPercent !== null"
                  class="mb-2 mt-4 h-2 rounded bg-gray-200  overflow-hidden">
                  <div class="h-2 bg-markencode-blue rounded" :style="{ width: arch.barWidthPercent + '%' }"></div>
                </div>

                <h3 class="text-xs font-semibold px-0.5">
                  {{ arch.name }}
                </h3>

                <!-- words (only if list has items) -->
                <p v-if="arch.wordsList && arch.wordsList.length" class="text-xs leading-relaxed text-gray-700 px-0.5">
                  {{ arch.wordsList.join(', ') }}
                </p>
                <p v-else class="text-xs leading-relaxed text-gray-700 px-0.5">
                  ---
                </p>
              </div>
            </div>
          </div>
          <!-- calculated action archetypes: end -->
        </div>
        <!-- actions tab: end -->





        <!-- info tab: start -->
        <div v-if="activeTab == 'info'" class="min-h-[3rem] grid grid-cols-1 divide-y-2 pb-6">
          <p v-if="selectedArchetype?.description?.short" class="text-xs py-1.5">{{ selectedArchetype.description.short
          }}</p>

          <p v-if="selectedArchetype?.description?.long" class="text-xs py-1.5">{{ selectedArchetype.description.long }}
          </p>

          <div v-if="selectedArchetype.wordZoneFactors" class="grid grid-cols-1 divide-y-2">
            <div v-for="(word, id) in selectedArchetype.wordZoneFactors" :key="id"
              class="text-xs flex items-center justify-between space-x-1 py-1.5">
              <p class="w-5/12">{{ word.word }}</p>
              <p class="w-3/12">Zone <span class="">{{ word.zone }}</span></p>
              <p class="w-3/12">Faktor {{ word.factor }}</p>

              <div class="w-1/12">
                <div v-if="word.factor === 0"
                  class="rounded-full w-3 h-3 ml-1 bg-transparent border border-gray-300 opacity-50"></div>

                <div v-if="word.factor === 1" class="rounded-full w-3 h-3 ml-1 bg-gray-400 border border-gray-300">
                </div>

                <div v-if="word.factor === 2" class="rounded-full w-3 h-3 ml-1 bg-white border border-white"></div>

                <div v-if="word.factor === 3"
                  class="rounded-full w-3 h-3 ml-1 bg-markencode-red border border-markencode-red"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- info tab: end -->

        <!-- design tab: start -->
        <div v-if="activeTab == 'design'" class="min-h-[3rem] grid grid-cols-1 divide-y-2 pb-6">

          <div class="flex items-start space-x-3">
            <!-- value system: start -->
            <div class="w-1/2">
              <div v-if="selectedArchetype.valueSystem?.length > 0">
                <p class="text-sm font-semibold mb-3">Wertesystem</p>

                <div v-for="(attribute, idx) in selectedArchetype.valueSystem" class="mb-3">
                  <p class="text-xs underline mb-0"
                    v-if="attribute.primary_words?.length > 0 || attribute.secondary_words?.length > 0 || attribute.tertiary_words?.length > 0">
                    {{ attribute.attribute_name }}</p>

                  <!-- primary words: start -->
                  <template v-if="attribute.primary_words?.length > 0">
                    <span v-for="(attributeWord, idx2) in attribute.primary_words">
                      <span class="text-xs text-markencode-red  leading-tight">{{ attributeWord.word }}, </span>
                    </span>
                  </template>
                  <!-- primary words: end -->

                  <!-- secondary words: start -->
                  <template v-if="attribute.secondary_words?.length > 0">
                    <span v-for="(attributeWord, idx3) in attribute.secondary_words">
                      <span class="text-xs text-gray-600 leading-tight">{{ attributeWord.word }}, </span>
                    </span>
                  </template>
                  <!-- secondary words: end -->

                  <!-- tertiary words: start -->
                  <template v-if="attribute.tertiary_words?.length > 0">
                    <span v-for="(attributeWord, idx4) in attribute.tertiary_words">
                      <span class="text-xs text-gray-400 leading-tight">{{ attributeWord.word }}, </span>
                    </span>
                  </template>
                  <!-- tertiary words: end -->
                </div>
              </div>
            </div>
            <!-- value system: end -->

            <!-- value area: start -->
            <div class="w-1/2">
              <div v-if="selectedArchetype.valueArea?.length > 0">
                <p class="text-sm font-semibold mb-3">Werteraum</p>

                <div v-for="(attribute, idx) in selectedArchetype.valueArea" class="mb-3">
                  <p class="text-xs underline mb-0"
                    v-if="attribute.primary_words?.length > 0 || attribute.secondary_words?.length > 0 || attribute.tertiary_words?.length > 0">
                    {{ attribute.attribute_name }}</p>

                  <!-- primary words: start -->
                  <template v-if="attribute.primary_words?.length > 0">
                    <span v-for="(attributeWord, idx2) in attribute.primary_words">
                      <span class="text-xs text-markencode-red  leading-tight">{{ attributeWord.word }}, </span>
                    </span>
                  </template>
                  <!-- primary words: end -->

                  <!-- secondary words: start -->
                  <template v-if="attribute.secondary_words?.length > 0">
                    <span v-for="(attributeWord, idx3) in attribute.secondary_words">
                      <span class="text-xs text-gray-600 leading-tight">{{ attributeWord.word }}, </span>
                    </span>
                  </template>
                  <!-- secondary words: end -->

                  <!-- tertiary words: start -->
                  <template v-if="attribute.tertiary_words?.length > 0">
                    <span v-for="(attributeWord, idx4) in attribute.tertiary_words">
                      <span class="text-xs text-gray-400 leading-tight">{{ attributeWord.word }}, </span>
                    </span>
                  </template>
                  <!-- tertiary words: end -->
                </div>
              </div>
            </div>
            <!-- value area: end -->

          </div>
        </div>
        <!-- design tab: end -->


        <!-- language tab: start -->
        <div v-if="activeTab == 'language'" class="min-h-[3rem] grid grid-cols-1 divide-y-2 pb-6">
          <p class="text-sm">---</p>
        </div>
        <!-- language tab: end -->
      </div>


    </section>

    <!-- <section
      class="min-w-0 flex-1 h-full max-w-sm mx-auto lg:order-last relative pt-3 px-3 select-none"
    >
    
    </section> -->

    <Teleport to="body">
      <definition-slideover :show="selectedDefinition !== null" :word="selectedDefinition"
        @cancelled="selectedDefinition = null"></definition-slideover>
    </Teleport>

    <Teleport to="body">
      <value-space-create-slideover :show="showValueSpaceCreation" :selected-words="selectedWords"
        @cancelled="hideValueSpaceCreation"></value-space-create-slideover>
    </Teleport>

    <Teleport to="body">
      <value-space-select-slideover :show="showValueSpaceSelection" @cancelled="hideValueSpaceSelection"
        @selected="selectStoredValueSpace" class="z-[60]"></value-space-select-slideover>
    </Teleport>
  </layout>
</template>

<script>
import Layout from '@/Pages/Markencode/Shared/MobileLayout.vue';
import DefinitionSlideover from '@/Pages/Markencode/Dictionary/Shared/DefinitionSlideover.vue';
import ValueSpaceCreateSlideover from '@/Pages/Markencode/Dictionary/Shared/ValueSpaceCreateSlideover.vue';

import ValueSpaceSelectSlideover from '@/Pages/Markencode/Dictionary/Shared/ValueSpaceSelectSlideover.vue';
import Teleport from 'vue2-teleport';

import Archetype from '@/Pages/Markencode/Dictionary/Shared/Archetype.vue';
import Spinner from '@/Pages/Markencode/Dictionary/Shared/Spinner.vue';
import SvgMatrix from '@/Pages/Markencode/Dictionary/Shared/SvgMatrix.vue';
import Matrix from '@/Pages/Markencode/Dictionary/Shared/Matrix.vue';
import ZoneColorIcons from '@/Pages/Markencode/Dictionary/Shared/ZoneColorIcons.vue';

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/splide.min.css';

import ClearFilterButton from '@/Shared/ClearFilterButton.vue';

import { throttle, some, isNotEmpty, map } from 'lodash';

export default {
  components: {
    Layout,
    DefinitionSlideover,
    ValueSpaceCreateSlideover,
    ValueSpaceSelectSlideover,
    ClearFilterButton,
    Splide,
    SplideSlide,
    Archetype,
    Spinner,
    SvgMatrix,
    Matrix,
    ZoneColorIcons,
    Teleport,
  },

  props: {
    filters: Object,
    words: Array,

    wordCategories: Array,

    queryParams: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      loading: false,
      activeTab: 'info',
      actionLoading: false,
      actionCalculating: false,
      calculatedActionArchetypes: {},
      // calculatedActionArchetypes: { "id": { "rank": 1, "barWidthPercent": 10, "name": "Abenteurer", "wordsList": ["word1", "word2"] }, "is": { "name": "Unschuldige", "wordsList": [] }, "ic": { "barWidthPercent": 5, "name": "Magier", "wordsList": ["worda"] } },
      allWords: this.words,
      allActions: [],
      actionPlaceholder: this.filters?.action?.word || 'Verhalten eingeben',
      selectedDefinition: null,
      selectedWords: [],
      // selectedWords: [{ "id": 72, "source": "old_profile_app", "source_id": null, "word": "analytisch", "definition": "Im Sinne von auf logischer Zergliederung, auf einem logisch zergliedernden Verfahren beruhend", "positive": 1, "zone": "c", "excluded": 0, "tentative": 0, "prio": null, "classification_completed_at": "2025-05-20T11:29:22.000000Z", "last_submitted_by": 3, "published_to_app_at": "2023-09-26T13:09:12.000000Z", "created_at": "2021-12-28T05:32:57.000000Z", "updated_at": "2025-05-20T11:29:22.000000Z", "zone_colors": "b", "status": "classified", "publish_status": "published", "slug": "72-analytisch" }, { "id": 84, "source": "old_profile_app", "source_id": null, "word": "diszipliniert", "definition": "Das konsequente Einhalten von bestimmten Vorschriften, vorgeschriebenen oder selbst gesetzten (Verhaltens-)Regeln", "positive": 1, "zone": "cd", "excluded": 0, "tentative": 0, "prio": null, "classification_completed_at": "2025-05-28T09:59:52.000000Z", "last_submitted_by": 3, "published_to_app_at": "2023-09-26T13:58:53.000000Z", "created_at": "2021-12-28T05:32:57.000000Z", "updated_at": "2025-05-28T09:59:52.000000Z", "zone_colors": "b-r", "status": "classified", "publish_status": "published", "slug": "84-diszipliniert" }],
      // selectedWords: [{ "id": 363, "source": "old_profile_app", "source_id": null, "word": "aufgeschlossen", "definition": "An neuen Themen oder Begegnungen interessiert und bereit, sich mit (neuen) Gedanken und Erkenntnisse (tiefer) auseinanderzusetzen.", "positive": 1, "zone": "is", "excluded": 0, "tentative": 0, "prio": null, "classification_completed_at": "2023-09-26T22:17:31.000000Z", "last_submitted_by": 3, "published_to_app_at": "2023-10-02T02:20:02.000000Z", "created_at": "2021-12-28T12:32:59.000000Z", "updated_at": "2023-10-02T02:20:02.000000Z", "zone_colors": "y-g", "status": "classified", "publish_status": "published", "slug": "363-aufgeschlossen" }, { "id": 21, "source": "old_profile_app", "source_id": null, "word": "verantwortungsvoll", "definition": "[mit einer bestimmten Aufgabe, einer bestimmten Stellung verbundene] Verpflichtung, Gefühl dafür zu sorgen (zu müssen), dass alles einen möglichst guten Verlauf nimmt und dafür alles Notwendige und Richtige getan wird", "positive": 1, "zone": "sd", "excluded": 0, "tentative": 0, "prio": null, "classification_completed_at": "2023-09-26T21:28:02.000000Z", "last_submitted_by": 3, "published_to_app_at": "2023-09-26T21:32:54.000000Z", "created_at": "2021-12-28T12:32:57.000000Z", "updated_at": "2023-09-26T21:32:54.000000Z", "zone_colors": "g-r", "status": "classified", "publish_status": "published", "slug": "21-verantwortungsvoll" }],
      selectedArchetype: {},
      validity: null,
      newWordProposalSent: false,
      internalError: false,
      archetypes: [],
      showValueSpaceCreation: false,
      showValueSpaceSelection: false,
      form: {
        search: this.filters.search,
        category: this.filters.category || null,
        action: this.filters.action || null,
        actionSearch: this.filters.actionSearch || null,

        // zone: this.filters.zone || { id: 'd', zone_colors: 'r' },
        zone: this.filters.zone || null,
        // wordAttributes: this.filters.wordAttributes
        //   ? this.filters.wordAttributes.map(Number)
        //   : [],
        // wordAttributesLogicalOperator:
        //   this.filters.wordAttributesLogicalOperator || 'or',
      },
    };
  },

  watch: {
    words: function () {
      this.allWords = this.words;

      // console.log(this.$refs.splider);

      if (this.$refs.splider !== undefined) {
        this.$refs.splider.remount();
      }

      this.$refs.search.focus();
    },


    'form.search': {
      handler: throttle(function () {
        if (this.form.search !== null && this.form.search.length < 2) {
          this.allWords = [];
          return;
        }

        this.newWordProposalSent = false;
        this.loading = true;

        this.$inertia.get(
          this.route('markencode.dictionary.index'),
          {
            ...this.queryParams,
            search: this.form.search,
            category: this.form.category,
            action: this.form.action,
            // wordAttributes: this.form.wordAttributes,
            // wordAttributesLogicalOperator:
            //   this.form.wordAttributesLogicalOperator,
            // page: 1,
          },
          {
            only: ['words', 'filters', 'queryParams'],
            preserveState: true,
            preserveScroll: true,
            onSuccess: () => {
              this.loading = false;
            },
          }
        );
      }, 150),
    },

    'form.actionSearch'() {
      if (this.form.actionSearch !== null && this.form.actionSearch.length < 2) {
        // this.allWords = [];
        return;
      }

      this.actionLoading = true;
      this.allActions = [];


      window.axios.post(this.route('markencode.dictionary.actions.fetch'), {
        ...this.queryParams,
        action: this.form.actionSearch,
      })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.allActions = response.data.actions;
          this.actionLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.actionLoading = false;
        });


    },

    selectedArchetype: function () {
      this.calculateActionArchetypes();
    },

    selectedWords: function () {
      this.calculateActionArchetypes();
    },

    'form.action'() {
      this.calculateActionArchetypes();
    },


    // calculateActions(newVal) {
    //   console.log('calcualteActions', newVal);
    //   if (!newVal) {
    //     return;
    //   }

    //   this.actionCalculating = true;
    //   this.allActions = [];


    //   window.axios.post(this.route('markencode.dictionary.actions.calculate'), {
    //     ...this.queryParams,
    //     action: this.form.action,
    //     selectedArchetype: this.selectedArchetype,
    //   })
    //     .then((response) => {
    //       console.log(response);
    //       this.calculatedActionArchetypes = response.data.archetypes;
    //       this.actionCalculating = false;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.actionCalculating = false;
    //     });
    // },

    // form: {
    //   handler: throttle(function () {
    //     if (this.form.search !== null && this.form.search.length < 2) {
    //       this.allWords = [];
    //       return;
    //     }

    //     this.newWordProposalSent = false;
    //     this.loading = true;

    //     this.$inertia.get(
    //       this.route('markencode.dictionary.index'),
    //       {
    //         ...this.queryParams,
    //         search: this.form.search,
    //         category: this.form.category,
    //         // wordAttributes: this.form.wordAttributes,
    //         // wordAttributesLogicalOperator:
    //         //   this.form.wordAttributesLogicalOperator,
    //         // page: 1,
    //       },
    //       {
    //         only: ['words', 'filters', 'queryParams'],
    //         preserveState: true,
    //         preserveScroll: true,
    //         onSuccess: () => {
    //           this.loading = false;
    //         },
    //       }
    //     );
    //   }, 150),

    //   deep: true,
    // },

    selectedWords: {
      handler: function () {
        this.archetypes = [];
        this.selectedArchetype = {};
        this.validity = null;
        this.internalError = false;
        // this.form.zone = null;

        if (this.selectedWords.length < 3) {
          return false;
        }

        this.loading = true;

        window.axios
          .post(this.route('markencode.dictionary.calculate'), {
            selectedWords: map(this.selectedWords, 'id'),
          })
          .then((response) => {
            console.log(response.data);
            this.archetypes = response.data.archetypes;
            this.validity = response.data.allWordsFitInValueZone;

            this.selectArchetype(this.archetypes[0]);
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.internalError = true;
          });
      },
    },
  },

  methods: {
    zoneSelected(zone) {
      console.log('zoneSelected');
      // this.form.zone = zone;
      // this.form.zone = null;

      this.form.search = '';
      this.newWordProposalSent = false;

      this.$inertia.get(
        this.route('markencode.dictionary.index'),
        {
          ...this.queryParams,
          zone: zone,
        },
        {
          only: ['words', 'filters', 'queryParams'],
          preserveState: true,
          preserveScroll: false,
        }
      );
    },

    //   wordAttributesToggled(attributes) {
    //     this.form.wordAttributes = attributes;
    //   },

    //   wordAttributesLogicalOperatorSet(logicalOperator) {
    //     this.form.wordAttributesLogicalOperator = logicalOperator;
    //   },

    selectAll() {
      this.$refs.search.select();
    },

    selectAllActions() {
      this.$refs.action.select();
    },

    selectWord(word) {
      console.log('selectWord');
      if (word.publish_status == 'published_and_blocked') {
        return;
      }

      if (this.selectedWords.length >= 33) {
        return;
      }

      if (!this.selectedWords.filter((item) => item.id == word.id).length) {
        this.selectedWords.push(word);
      }

      var url = new URL(window.location.href);
      var search_params = url.searchParams;
      search_params.set('search', '');
      url.search = search_params.toString();
      window.history.pushState({}, '', url.toString());

      this.form.search = '';
      // console.log(this.form.zone);
      // this.form.zone = null;

      // console.log(word);
    },

    selectDefinition(word) {
      console.log('selectedDefinition');
      this.selectedDefinition = word;
    },

    deselectWord(word) {
      console.log('deselectWord');
      this.selectedWords = this.selectedWords.filter(
        (item) => item.id != word.id
      );

      // console.log(word);
    },

    reset() {
      console.log('reset');
      this.$inertia.get(this.route('markencode.dictionary.index'), {});
      this.newWordProposalSent = false;
      // this.form.search = '';
      // this.form.status = '';
      // this.form.wordAttributes = [];
      // this.form.wordAttributesLogicalOperator = 'or';
    },

    hideValueSpaceSelection() {
      this.showValueSpaceSelection = false;
    },

    hideValueSpaceCreation() {
      this.showValueSpaceCreation = false;
    },

    selectArchetype(archetype) {
      this.selectedArchetype = archetype;
    },

    proposeNewWord() {
      if (!this.form.search) {
        return;
      }

      // this.loading = true;
      this.newWordProposalSent = false;

      window.axios
        .post(this.route('markencode.dictionary.propose-new-word'), {
          word: this.form.search,
        })
        .then((response) => {
          this.newWordProposalSent = true;
          // this.loading = false;
        })
        .catch(function (error) {
          // this.loading = false;
        });
    },

    selectStoredValueSpace(words) {
      this.selectedWords = words;
      this.showValueSpaceSelection = false;
    },


    selectAction(action) {
      this.form.action = action;
      this.form.actionSearch = '';
      this.actionPlaceholder = action.word;
      this.allActions = [];
    },

    resetAction() {
      this.form.action = null;
      this.form.actionSearch = '';
      this.actionPlaceholder = 'Verhalten eingeben';
      this.calculatedActionArchetypes = {};
    },


    calculateActionArchetypes() {
      console.log('calculateActionArchetypes: ' + this.actionArchetypesCanBeCalculated);

      if (!this.actionArchetypesCanBeCalculated) {
        return;
      }

      console.log('calculateActionArchetypes: go');


      this.actionCalculating = true;
      this.allActions = [];


      window.axios.post(this.route('markencode.dictionary.actions.calculate'), {
        ...this.queryParams,
        action: this.form.action,
        selectedArchetype: this.selectedArchetype,
      })
        .then((response) => {
          console.log(response);
          this.calculatedActionArchetypes = response.data.actionArchetypes;
          this.actionCalculating = false;
        })
        .catch((error) => {
          console.log(error);
          this.actionCalculating = false;
        });
    },
  },

  computed: {
    isFiltered() {
      return some(this.form, isNotEmpty);
    },

    splideOptions() {
      return {
        type: 'slide',
        rewind: false,
        arrows: false,
        // pagination: this.showPagination,
        pagination: true,
        perPage: 2,
        perMove: 1,
        gap: '1em',
      };
    },

    splideOptionsArchetype() {
      return {
        type: 'slide',
        rewind: true,
        arrows: false,
        // pagination: this.showPagination,
        pagination: true,
        perPage: 5,
        perMove: 1,
        padding: { left: '10px' },
      };
    },

    showPagination() {
      if (this.allWords.length > 1) {
        return true;
      }

      return false;
    },

    message() {
      if (this.form.search === null || !this.form.search) {
        return 'Bitte Werte wählen';
      }

      if (
        this.form.search !== null &&
        this.form.search.length > 0 &&
        this.form.search.length < 2
      ) {
        return 'Bitte mindestens zwei Zeichen eingeben';
      }

      // if (
      //   this.form.search !== null &&
      //   this.form.search.length >= 2 &&
      //   !this.loading
      // ) {
      //   return 'Keine Worte vorhanden';
      // }

      return '';
    },

    canProposeNewWord() {
      return (
        this.form.search !== null &&
        this.form.search.length >= 2 &&
        !this.loading
      );
    },

    canStoreValueSpace() {
      return this.selectedWords.length >= 3;
    },


    actionArchetypesCanBeCalculated() {
      return this.form.action && Object.keys(this.selectedArchetype).length > 0;
    },


    displayedActionArchetypes() {
      const src = this.calculatedActionArchetypes || {};

      return Object.entries(src)
        .map(([key, val]) => (val ? { _key: key, ...val } : null))
        .filter(Boolean);
    },


    // displayedActionArchetypes() {
    //   const items = Object.keys(this.calculatedActionArchetypes || {})
    //     .map(k => this.calculatedActionArchetypes[k])
    //     .filter(Boolean);

    //   return items.sort((a, b) => {
    //     const ra = (a.rank !== undefined && a.rank !== null) ? a.rank : 1e9;
    //     const rb = (b.rank !== undefined && b.rank !== null) ? b.rank : 1e9;
    //     return ra - rb;
    //   });
    // },


    canSeeBetaFunctionalities() {
      return this.$page.props.auth.user.can.use?.dictionary_beta || this.$page.props.auth.user.is.admin;
    },



  },
};
</script>

<style>
.splide__pagination {
  @apply -bottom-5;
}

.splide__pagination__page.is-active {
  @apply bg-gray-400;
}

.splide__list {
  /* not good */
  /* justify-content: center;
  width: auto; */
}
</style>
